import React, { Component } from 'react';

import {Filter} from '../components/filter';

class FilterContainer extends Component {
  render() {
    const {cmdDate, cmdDateChange, viewMode, changeViewMode} = this.props;
    return (
      <Filter 
        viewMode={viewMode}
        cmdDate={cmdDate}
        cmdDateChange={cmdDateChange}
        changeViewMode={changeViewMode}
      />
      
    );
  }
}

export default FilterContainer;


// WEBPACK FOOTER //
// ./src/containers/FilterContainer.js